export default __webpack_public_path__ + "4abcfc58d4c82f797b0d30d697229308.svg";